import type { Microsoft365Source } from '@dbrain/shared';
import { MicrosoftIcon } from '../MicrosoftIcon.js';

/**
 * A source's picture on a tile (MsEkleMenu, MsBelgeSec, MsBelgelerKaynak): Microsoft's own OneDrive, SharePoint or
 * Outlook icon (v0.15g.1, D-254; the mockups' dashed boxes were its placeholders), unchanged and at its own size, on a
 * neutral tile like the "+" menu's other rows (the phone's too): 34 px with the 20 px icon in the "+" menu, 26 px with
 * the 16 px icon in the picker's left side and the Belgeler box. The source's name always comes right after it.
 */
export function SourceTile({ source, size = 'md' }: { source: Microsoft365Source; size?: 'md' | 'lg' }) {
  return (
    <span className={`m365-src-tile m365-src-tile--${size}`} aria-hidden="true">
      <MicrosoftIcon product={source} size={size === 'lg' ? 20 : 16} />
    </span>
  );
}
